import React, { type FC } from 'react';

import { Inline } from '@atlaskit/primitives';

import { PrincipalDetails, type PrincipalDetailsProps } from './PrincipalDetails';
import { PrincipalAccess, type PrincipalAccessProps } from './PrincipalAccess';

export type SpecificAccessRowProps = {
	key: string;
	principalDetails: PrincipalDetailsProps;
	principalAccess: PrincipalAccessProps;
};

export const SpecificAccessRow: FC<SpecificAccessRowProps> = ({
	principalDetails,
	principalAccess,
}) => (
	<Inline grow="fill" spread="space-between" alignBlock="center" space="space.150">
		<PrincipalDetails {...principalDetails} />
		<PrincipalAccess {...principalAccess} />
	</Inline>
);
